import { render, staticRenderFns } from "./loginTeacher.vue?vue&type=template&id=c6838360&"
import script from "./loginTeacher.vue?vue&type=script&lang=js&"
export * from "./loginTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports